import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getName } from 'common/personUtils';
import { renderDate } from 'common/dateUtils';
import {
  getPendingOrConnectedEnrollmentsByEndDate,
  EnrollmentConnectionStatusEnum,
} from 'common/enrollmentUtils';

import TableStyles from 'styles/table.css';
import connectionStyles from 'styles/connectionStatus.css';

export const customCellRenderer = ({ rowData, dataKey }) => {
  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>{rowData[dataKey]}</p>
    </div>
  );
};
export const customColumnCellRenderer = ({ rowData, dataKey }) => {
  const { participantCustomFields } = rowData;
  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>
        {participantCustomFields &&
          participantCustomFields[dataKey] &&
          participantCustomFields[dataKey].fieldValue}
      </p>
    </div>
  );
};
export const patientCellRenderer = ({ rowData }) => {
  const rec = rowData;
  const primaryText = getName(rec.firstName, rec.lastName, '');
  const secondaryText = rec.customParticipantID;

  const secondaryTextClassName = `${TableStyles.secondaryText} ${TableStyles.number}`;
  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>{primaryText}</p>
      <p className={secondaryTextClassName}>{secondaryText}</p>
    </div>
  );
};

export const dobCellRenderer = ({ rowData, ...props }) => {
  const patient = rowData;
  const { me } = props.parent.props;
  return (
    <div className={TableStyles.centeredColumnContent}>
      <p className={`${TableStyles.primaryText} ${TableStyles.centeredText}`}>
        {patient.dob && renderDate(patient.dob, me)}
      </p>
    </div>
  );
};

export const orderingProviderCellRenderer = ({ rowData }) => {
  const patient = rowData;
  const physician =
    patient.orderingPhysician &&
    getName(
      patient.orderingPhysician.firstName,
      patient.orderingPhysician.lastName,
      '',
    );

  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>{physician}</p>
    </div>
  );
};

export const connectionStatusCellRenderer = ({ rowData }) => {
  const patient = rowData;
  let content;

  switch (patient.connectionStatus) {
    case EnrollmentConnectionStatusEnum.CONNECTED:
      content = (
        <p className={connectionStyles.connectionStatusConnected}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.CONNECTED}`}
          />
        </p>
      );
      break;
    case EnrollmentConnectionStatusEnum.PENDING:
      content = (
        <p className={connectionStyles.connectionStatusPending}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.PENDING}`}
          />
        </p>
      );
      break;
    case EnrollmentConnectionStatusEnum.DISCONNECTED:
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.DISCONNECTED}`}
          />
        </p>
      );
      break;
    case EnrollmentConnectionStatusEnum.REVOKED:
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.REVOKED}`}
          />
        </p>
      );
      break;
    case EnrollmentConnectionStatusEnum.EXPIRED:
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.EXPIRED}`}
          />
        </p>
      );
      break;
    case EnrollmentConnectionStatusEnum.NONE:
    default:
      content = (
        <p className={connectionStyles.connectionStatusNotConnected}>
          <FormattedMessage
            id={`enrollment.connection.status.${EnrollmentConnectionStatusEnum.NONE}`}
          />
        </p>
      );
      break;
  }
  return <div className={TableStyles.centeredColumnContent}>{content}</div>;
};

export const connectionPlanCellRenderer = ({ rowData }) => {
  const { enrollments } = rowData;
  let currentEnrollment;

  if (enrollments && enrollments.length > 0) {
    const pendingOrConnectedEnrollments = getPendingOrConnectedEnrollmentsByEndDate(
      enrollments,
    );

    if (pendingOrConnectedEnrollments.length > 0) {
      currentEnrollment = { ...pendingOrConnectedEnrollments[0] };
    }
  }

  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>
        {currentEnrollment && currentEnrollment.connectionTemplateName}
      </p>
    </div>
  );
};

export const billingCodeCellRenderer = ({ rowData }) => {
  const { enrollments } = rowData;
  let currentEnrollment;
  let text;

  if (enrollments && enrollments.length > 0) {
    const pendingOrConnectedEnrollments = getPendingOrConnectedEnrollmentsByEndDate(
      enrollments,
    );

    if (pendingOrConnectedEnrollments.length > 0) {
      currentEnrollment = { ...pendingOrConnectedEnrollments[0] };
    }
  }

  if (
    currentEnrollment &&
    currentEnrollment.billingCodes &&
    currentEnrollment.billingCodes.length > 0
  ) {
    text = currentEnrollment.billingCodes[0].name;
  }

  return (
    <div className={TableStyles.columnContent}>
      <p className={TableStyles.primaryText}>{text}</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/components/Table/CellRenderers.jsx